var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.437 6.354H16.77M8.437 9.687v5m3.333-5v5m-7.5-8.333l.834 10A1.667 1.667 0 006.77 18.02h6.667a1.667 1.667 0 001.667-1.666l.833-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.604 6.354v-2.5a.833.833 0 01.833-.833h3.333a.833.833 0 01.834.833v2.5"
  }))));
};
export default SvgDelete;